import React from 'react';
import { toast } from 'react-toastify';
import { call, put } from 'redux-saga/effects';

import { Creators as WebhookIntegration } from '../ducks/webhookIntegration';

import { WebhookIntegrationAPI } from '../../services/api';

import { ErrorToast } from '../../components/molecules/Toast';

export function* getWebhookEventsList() {
  try {
    const response = yield call(WebhookIntegrationAPI.get, `/list-events`);
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookIntegration.getWebhookListEventsResponse(response.data, isSuccess)
    );
  } catch (error) {
    WebhookIntegration.getWebhookListEventsResponse({}, false);
  }
}
export function* getWebhookConfiguration() {
  try {
    const response = yield call(WebhookIntegrationAPI.get, `/configuration`);
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookIntegration.getWebhookConfigurationResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    WebhookIntegration.getWebhookConfigurationResponse({}, false);
  }
}

export function* postWebhook(action) {
  try {
    const response = yield call(WebhookIntegrationAPI.post, `/post`, {
      isActive: false,
    });
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookIntegration.getWebhookConfigurationResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    toast.error(<ErrorToast size="30">{error.response.data}</ErrorToast>);
  }
}
export function* deleteWebhook(action) {
  const idWebhook = action.payload;
  try {
    const response = yield call(WebhookIntegrationAPI.delete, `${idWebhook}`, {
      isActive: true,
    });
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookIntegration.getWebhookConfigurationResponse(null, isSuccess)
    );
  } catch (error) {
    toast.error(<ErrorToast size="30">{error.response.data}</ErrorToast>);
  }
}
export function* putWebhook(action) {
  const { params } = action.payload;
  try {
    const response = yield call(WebhookIntegrationAPI.put, `/put`, params);
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookIntegration.getWebhookConfigurationResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    toast.error(<ErrorToast size="30">{error.response.data}</ErrorToast>);
  }
}
